import React from "react";
import css from "./main-menu.module.scss";

interface IMainMenuHeaderProps
{
    transparentHeader: boolean;
    heroColor: string;
}

export const MainMenuHeader = ({ transparentHeader, heroColor }: IMainMenuHeaderProps): React.FunctionComponentElement<unknown> =>
    <ul className={`${css["menu-header"]} ${transparentHeader && heroColor === 'black' ? 'text-white' : ''}`}>
        <li data-main-menu-activate="products">Products</li>
        <li data-main-menu-activate="customize">Customize</li>
        <li data-main-menu-activate="why-active">Why ACTIVE</li>
        <li data-main-menu-activate="support">Support</li>
        <li data-main-menu-activate="contact">Contact</li>
    </ul>;
